import type { Container, Sprite, Text } from 'pixi.js';
import { onLayoutPopulated } from '../populate';
import type { AllProps } from '../../propsMixin/props';

type DisplayObjectWithProps = (Sprite | Container | Text) & { data: { props: AllProps } };

export function layoutPropsSPL(): void {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  onLayoutPopulated.connect((layout: { root: Container; props_SPL?: DisplayObjectWithProps[] }) => {
    if (!layout.props_SPL) return;

    layout.props_SPL.forEach((object) => {
      if (!object.data?.props) return;
      object.props(object.data.props);
    });
  });
}
